import React from 'react';
import {IWithDisabled} from 'models';
import {IntegrationTypeFilter} from './IntegrationTypeFilter';

export const IntegrationTypeMultiFilter = ({disabled}: IWithDisabled) => (
  <IntegrationTypeFilter selectionType="multi" disabled={disabled} />
);
